import { render, staticRenderFns } from "./searchArea.vue?vue&type=template&id=24a1e00b"
import script from "./searchArea.vue?vue&type=script&lang=js"
export * from "./searchArea.vue?vue&type=script&lang=js"
import style0 from "./searchArea.vue?vue&type=style&index=0&id=24a1e00b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports